import { InviteDetails, PreferredApp } from '../types';
import { branchUrlFactory } from './branch-links';

const LINK_PREFIX = 'https://invites.wix.com/clubs/invites';
const SKIP_LP_REF = 'skip_lp';

type GetAppLinkParams = {
  inviteDetails: InviteDetails;
  shouldAddSkipLPRef?: boolean;
};

const getAppLink = (params: GetAppLinkParams): string => {
  const { inviteDetails, shouldAddSkipLPRef } = params;
  const urlQueryParams = new URLSearchParams(window.location.search);
  const queryParams = Object.fromEntries(urlQueryParams.entries());
  const { passportId, encryptedToken, appName } = queryParams;
  const { appType, businessId, inviteId, ref } = inviteDetails;
  const app = (appName as PreferredApp) ?? appType;
  const inviteIdUrlParam = inviteId ? `/${inviteId}` : '';

  if (app === 'WixBrandedApp') {
    const { urlScheme } = inviteDetails;
    return `${urlScheme}://auth/loginMagicLink/${passportId}`;
  }
  return branchUrlFactory(app)(
    `${LINK_PREFIX}/${businessId}${inviteIdUrlParam}`,
    {
      ref: shouldAddSkipLPRef
        ? ref
          ? `${ref}|${SKIP_LP_REF}`
          : `${SKIP_LP_REF}`
        : ref,
      passportId,
      encryptedToken,
    },
  );
};

const openAppLink = (inviteDetails: InviteDetails, isRedirect?: boolean): void => {
  if (inviteDetails) {
    const appLink = getAppLink({ inviteDetails });
    if (isRedirect) {
      window.location.assign(appLink);
    } else {
      window.open(appLink);
    }
  }
};

export const appLinkService = {
  getAppLink,
  openAppLink,
};
